export const BASE_URL = '/app/reporting';
export const REPORTING_MODULE_SWITCH = 'reporting_module';
